import React, { Component } from 'react';
import BIN from '../../img/rubbish-bin.png'
import DOWNLOAD from '../../img/download-button.png'
class raporList extends Component {

  render() {
    function NumberList(props) {
      console.log(props)
      const numbers = props.numbers;
      const silolay = props.silme;
      const indirolay = props.indirme;
      const yetkili = props.yetki;
      function dosyaadci(item) {
        var a = item.DosyaAd;
        var dosyatemp = [];
        dosyatemp = a.split('/');
        console.log(dosyatemp)
        if (dosyatemp[6]) {
          var dosyaRealPath = dosyatemp[6].replace('.pdf', '');
          return dosyaRealPath;
        } else {
          return ""
        }

      }
      function tarihadci(item) {
        var a = item.Tarih;
        var tarihtemp = [];
        tarihtemp = a.split('T');
        var tarihi = tarihtemp[0];
        return tarihi;
      }
      //
      const listItems = numbers.map((number) => {
        if(!number.DosyaAd.includes("FERAGAT")) //Feragatları gizlemek için kullandım
        return <li key={number.SiraNo}>
          <div className="raportasiyici">
            <div className="adi">Rapor Adı: {dosyaadci(number)}</div>
            <div className="tarih">Tarih: {tarihadci(number)}</div>
          </div>
          {yetkili ? <button className="silbuton"
            onClick={silolay.bind(this, number)}>
            <img src={BIN} alt="submit" />
          </button> : false}
          <button className="indirbuton" onClick={indirolay.bind(this, number)}>
            <img src={DOWNLOAD} alt="submit" />
          </button>
          {/*<a href={link+number.ID}>İndir</a>*/}
        </li>
      }
      );
      return (
        <ul>{listItems}</ul>
      );
    }

    return (
      <div className="icerik" >
        <NumberList
          numbers={this.props.numbers}
          indirme={this.props.indir}
          silme={this.props.sil}
          yetki={this.props.yetki}
        />
      </div>
    );
  }
}

export default raporList;
